<template>
	<div class="row">
		<div class="col-12 font-weight-500">Endereço do atendimento</div>
		<div class="col-12">
			<Endereco 
				tipoEndereco="Origem" 
				:endereco="enderecoOrigem" 
				:segundaSaida="servico.segundaSaida || false"
				:status="status"
				:idServicoAtendimento="servico.idServicoAtendimento || ''"
			/>
		</div>
		<div class="col-12 mb-1">
			<Endereco 
				tipoEndereco="Destino" 
				:endereco="enderecoDestino" 
				:segundaSaida="servico.segundaSaida || false"
				:status="status" 
				:idServicoAtendimento="servico.idServicoAtendimento || ''"
			/>
		</div>

		<div class="col-12 lh-18 mt-2 pl-1 pr-1 text-center" v-if="exibirPrevisao">
			<table class="table table-bordered table-sm border-left-right-0 m-0" id="previsao-tempo">
				<tbody>
					<tr>
						<td class="border-left-0 small w-50">
							Previsão {{ tempoEmMinutos(servico.previaServico) }} min
							<span class="material-symbols-outlined" style="vertical-align: top;">history</span>
							<br>
							<small>
								Inserido em {{ removeSegundos(servico.dataCadastroServico) }}
							</small>
						</td>
						<td class="border-right-0 small w-50">
							<div v-if="isEmpty(servico.dataHorarioChegada)">
								<span v-if="tempoRestante <= 0" class="text-success">
									Restando {{ tempoRestante * -1 }} min.
								</span>
								<span v-else>
									Restando 0 min.
								</span>
							</div>
							<div v-else>
								<div v-if="tempoRestante <= 0" class="text-success">No prazo</div>
								<div>Chegou com {{ tempoChegada }} min.</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="col-12 mt-1 text-end" v-if="exibirRastreioPrestadores == 'S'">
			<small class="text-warning me-1">
				<span class="material-symbols-outlined">info</span> Atendimento rastreável
			</small>
			<button type="button" class="btn btn-purple btn-sm font-11 float-right" @click="atualizarDados">
				Atualizar rastreio <span class="material-symbols-outlined">refresh</span>
			</button>
        </div>
	</div>

</template>

<script setup>
import Endereco from '@/components/Endereco.vue';
import { ref, defineProps, computed, onMounted, onUnmounted, watch } from 'vue'
import { tempoEmMinutos, removeSegundos, isEmpty } from '@/helper/funcoes.js';
import { storeToRefs } from 'pinia';
import { useAtendimentoStore } from '@/stores/atendimento';
import moment from 'moment';

const store = useAtendimentoStore();
const { totalServicos, idAtendimentoUrl } = storeToRefs(store);

const props = defineProps({
	enderecoOrigem: {
		type: Object,
		default: () => ({})
	},
	enderecoDestino: {
		type: Object,
		default: () => ({})
	},
	servico: {
		type: Object,
		default: () => ({})
	},
	status: String,
	exibirRastreioPrestadores: String
});

const arrayStatus = [
	'PRESTADOR_ACIONADO',
	'PRESTADOR_A_CAMINHO',
	'PRESTADOR_CHEGOU_LOCAL',
	'VIAJANDO_PARA_DESTINO',
	'FINALIZADO'
];

let tempoRestante = ref(0);
let intevaloAtualizaTempoRestante = ref(null);

const exibirPrevisao = computed(() => totalServicos.value > 0 && arrayStatus.indexOf(props.status) > -1);

const tempoChegada = computed(() => {
	if (isEmpty(props.servico.dataCadastroServico) || isEmpty(props.servico.dataHorarioChegada)) {
		return 0;
	}
	const chegada = moment(props.servico.dataHorarioChegada, "DD/MM/YYYY HH:mm:ss");
	const acionado = moment(props.servico.dataCadastroServico, "DD/MM/YYYY HH:mm:ss");
	const duration = moment.duration(chegada.diff(acionado));
	let tempo = parseInt(duration.asMinutes());
	return tempo < 0 ? tempo * -1 : tempo;
});

function montarTempoRestante() {
	if (isEmpty(props.servico.dataHorarioChegada)) {
		tempoRestante.value = 0;
		if (exibirPrevisao.value && !isEmpty(props.servico.previaServico) && !isEmpty(props.servico.dataExecucaoServico)) {
			const previsaoMinutos = tempoEmMinutos(props.servico.previaServico);
			const dataLimite = moment(props.servico.dataExecucaoServico, "DD/MM/YYYY HH:mm:ss").add(previsaoMinutos, 'minutes');
			const agora = moment();
			
			const diferenca = agora.diff(dataLimite);
			tempoRestante.value = parseInt(moment.duration(diferenca).asMinutes());
		}		
	} else {
		limparIntervalo();
	}
}

function atualizarTempoRestante() {
	limparIntervalo();
	intevaloAtualizaTempoRestante.value = setInterval(() => {
		montarTempoRestante();
	}, 15000);
}

function limparIntervalo() {
	if (intevaloAtualizaTempoRestante.value) {
		clearInterval(intevaloAtualizaTempoRestante.value)
		intevaloAtualizaTempoRestante.value = null
	}
}

function atualizarDados() {	
	store.buscarDadosAtendimento({idAtendimento: idAtendimentoUrl.value, atualizar: true});         
}

onMounted(() => {
	montarTempoRestante();
	atualizarTempoRestante();
});

onUnmounted(() => {
	limparIntervalo();
})

watch(() => props.servico, () => {
	montarTempoRestante()
}, { deep: true });
</script>

<style scoped>
.border-left-right-0 {
	border-left-width: 0 !important;
	border-right-width: 0 !important;
}

.border-left-0 {
	border-left-width: 0 !important;
}

.border-right-0 {
	border-right-width: 0 !important;
}

#previsao-tempo td {
	vertical-align: middle;
}
</style>
